import {
  PaginatedSelect,
  BasePaginatedSelectProps,
  PaginatedSelectQueryProps,
  PaginatedDefaultProps,
  PaginatedSingleProps,
  PaginatedMultiProps,
  ParseMultipleItems,
  ParseSingleItem,
} from '../PaginatedSelect';
import {
  Campaign,
  fetchCampaignsQuery,
  fetchCampaignQuery,
  parseCampaignsResponse,
  parseCampaignResponse,
} from './CampaignSelect.queries';

export const CAMPAIGN_SELECT_PLACEHOLDER = {
  SINGLE: 'Select a Campaign',
  MULTI: 'Select Campaigns',
};

export type FetchCampaignParams = {
  search?: string;
};

export const getCampaignSelectFetchItemsVariables = ({ search }: FetchCampaignParams = {}) => ({
  search,
});

export type CampaignSelectProps<TItem extends Campaign = Campaign> = BasePaginatedSelectProps &
  Partial<PaginatedSelectQueryProps<TItem>> &
  (PaginatedDefaultProps | PaginatedSingleProps | PaginatedMultiProps);

const defaultVariables = getCampaignSelectFetchItemsVariables();

export function CampaignSelect<TItem extends Campaign = Campaign>(
  props: CampaignSelectProps<TItem>,
) {
  return (
    <PaginatedSelect
      fetchAllItemsQuery={fetchCampaignsQuery}
      fetchAllItemsParser={parseCampaignsResponse as ParseMultipleItems<TItem>}
      fetchAllItemsVariables={defaultVariables}
      fetchSelectedItemQuery={fetchCampaignQuery}
      fetchSelectedItemParser={parseCampaignResponse as ParseSingleItem<TItem>}
      placeholder={
        props?.isMulti ? CAMPAIGN_SELECT_PLACEHOLDER.MULTI : CAMPAIGN_SELECT_PLACEHOLDER.SINGLE
      }
      hasError={props.isError}
      {...props}
    />
  );
}

export default CampaignSelect;
